import axios from "axios";

export const api = axios.create({
  baseURL: window.__APP_CONFIG__.API_URL,
});
